import { CUSTOMER_BASE_URL } from '@synergy/config';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import urlJoin from 'url-join';

import { ROUTES } from '../../utils/routes';

/** Where each of the shop's former order tabs lives in the member portal. */
const PORTAL_PATHS: Record<string, string> = {
    again: 'buy-again',
    pending: 'order-approvals',
};

/**
 * The orders, their approval and buying again moved to the member portal
 * (#2279, #2280, #2281, #2282); old links, bookmarks and mails to the shop's
 * order tabs land on the same page there.
 */
export const Orders = (): null => {
    const location = useLocation();

    useEffect(() => {
        const tab = location.pathname.slice(ROUTES.orders.length).replace(/^\/+/, '').split('/')[0];

        window.location.replace(urlJoin(CUSTOMER_BASE_URL, PORTAL_PATHS[tab] ?? 'orders'));
    }, [location.pathname]);

    return null;
};
